import { CONST } from "../../../CONST";
import Distraction, { DistractionConfig, DistractionState} from "../Distraction";

const CONFIG = {
    vibration: {
        duration: 1000,
        timeBetweenPulses: 500,
    },

    startTime: 500,
    endTime: 500,
}

export default class PhoneDistraction extends Distraction {

    private phoneContainer : Phaser.GameObjects.Container;
    private phoneImg : Phaser.GameObjects.Image;
    private phoneScreenImg : Phaser.GameObjects.Image;

    private phoneBuzz_1: Phaser.GameObjects.Image;
    private phoneBuzz_2: Phaser.GameObjects.Image;

    private vibratingTween!: Phaser.Tweens.Tween;
    private vibratingTimeline!: Phaser.Tweens.Timeline;
    private screenTween !: Phaser.Tweens.Tween;
    

    constructor(scene: Phaser.Scene, config: DistractionConfig){
        super(scene, config);

        this.phoneContainer = scene.add.container(config.x, config.y).setDepth(config.depth);

        this.phoneImg = scene.add.image(0, 0, CONST.DISTRACTION.PHONE);
        this.phoneScreenImg = scene.add.image(3, -6, CONST.DISTRACTION.PHONE_MESSAGE_3).setAlpha(0);
        this.phoneBuzz_1 = scene.add.image(-85, 15, CONST.DISTRACTION.PHONE_BUZZ_1).setAlpha(0);
        this.phoneBuzz_2 = scene.add.image(35, -47, CONST.DISTRACTION.PHONE_BUZZ_2).setAlpha(0);

        let phoneShadow = scene.add.image(0, 16, CONST.DISTRACTION.PHONE_SHADOW);

        this.phoneImg.setInteractive({useHandCursor: true, pixelPerfect: true, alphaTolerance: 1});

        this.phoneImg.on("pointerup", () => {
            this.handleClick();
        });

        this.phoneContainer.add([phoneShadow, this.phoneImg, this.phoneScreenImg, this.phoneBuzz_1, this.phoneBuzz_2]);
        this.init();
    }

    private handleClick(){
        this.deactivate();
    }

    onDeactivated(): void {
        this.phoneImg.clearTint();
    }

    onStarting(): void {
        this.startVibrating();

        setTimeout(() => {
            this.changeState(DistractionState.Active);
        }, CONFIG.startTime);

    }

    onActivated(): void {
    }

    onEnding(): void {
        this.stopVibrating();

        setTimeout(() => {
            this.changeState(DistractionState.Deactivated);
        }, CONFIG.endTime);
    }

    onGameLost(): void {
        this.phoneImg.disableInteractive();
    }

    startVibrating(){
        let phoneScreen = this.phoneScreenImg;
        phoneScreen.setAlpha(1);

        let s = this.scene;
        this.screenTween = this.scene.tweens.addCounter({
            from: 0,
            to: 3,
            duration: 3*CONFIG.vibration.duration,        
            onUpdate: function(tween:Phaser.Tweens.Tween){
                var value = Math.floor(tween.getValue());
                switch(value){
                    case 0:
                        if (phoneScreen.texture.key === CONST.DISTRACTION.PHONE_MESSAGE_1) break;
                        phoneScreen.setTexture(CONST.DISTRACTION.PHONE_MESSAGE_1);
                        s.sound.play(CONST.AUDIO.POP, {detune: -200, volume: 5});
                        break;
                    case 1:
                        if (phoneScreen.texture.key === CONST.DISTRACTION.PHONE_MESSAGE_2) break;
                        phoneScreen.setTexture(CONST.DISTRACTION.PHONE_MESSAGE_2);
                        s.sound.play(CONST.AUDIO.POP, {detune: 0, volume: 5});
                        break;
                    case 2:
                        if (phoneScreen.texture.key === CONST.DISTRACTION.PHONE_MESSAGE_3) break;
                        phoneScreen.setTexture(CONST.DISTRACTION.PHONE_MESSAGE_3);
                        s.sound.play(CONST.AUDIO.POP, {detune: 200, volume: 5});
                        break;
                }
            }
        });

       this.vibratingTween = this.scene.tweens.add({
            targets: this.phoneContainer,
            x: "+=2",
            y: "+=2",
            angle: "+=1",
            duration: CONFIG.vibration.duration,
            hold: CONFIG.vibration.timeBetweenPulses,
            ease: (t: number) => {return this.wiggle(t, 5, 5)},
            onStart: () => {
                this.scene.sound.play(CONST.AUDIO.VIBRATE, {volume: 14});
            },
            onRepeat: () => {
                this.scene.sound.play(CONST.AUDIO.VIBRATE, {volume: 14});
            },    
            repeat: -1,
        });

        this.vibratingTimeline = this.scene.tweens.timeline({
            targets: [this.phoneBuzz_1, this.phoneBuzz_2],
            loop: -1,
             tweens: [
                 {
                    alpha: 1,
                    duration: 100,
                    hold: CONFIG.vibration.duration - 500,
                    ease: "Quad.easeInOut"
                 },
                 {
                     alpha: 0,
                     duration: 400,
                     hold: CONFIG.vibration.timeBetweenPulses,
                     ease: "Quad.easeInOut",
                 },
             ]
        });
    }

    stopVibrating(){
        if (this.vibratingTimeline){
            this.vibratingTimeline.stop();
        }
        if (this.vibratingTween){
            this.vibratingTween.stop();
        }
        if (this.screenTween){
            this.screenTween.stop();
        }

        this.phoneBuzz_1.setAlpha(0);
        this.phoneBuzz_2.setAlpha(0);
        this.phoneScreenImg.setAlpha(0);
        this.phoneScreenImg.setTexture(CONST.DISTRACTION.PHONE_MESSAGE_3);


        //Reset phone position
        this.phoneContainer.setAngle(0).setPosition(this.config.x, this.config.y);

    }

    private wiggle(aProgress: number, aPeriod1: number, aPeriod2: number): number {
        var current1: number = aProgress * Math.PI * 2 * aPeriod1;
        var current2: number = aProgress * (Math.PI * 2 * aPeriod2 + Math.PI / 2);

        return Math.sin(current1) * Math.cos(current2);
    }
    
}